import React, {Component} from 'react';
import {
    Button, Grid, Dialog, DialogActions, DialogTitle,
    DialogContent, Typography
} from 'material-ui';
import {BackDropCMS} from '../../../components/backdrop/backdrop_cms';
import SectionListEditable from '../sections/tab_edit/section_list';
import PageBuilderMeta from '../sections/tab_edit/builder_meta';

class PageVersionViewPopup extends Component {

    render() {
        const {
            pageMeta,
            pageVersion,
            pageSections,
            classes,
            handleSubmitView,
            handleCloseView,
            open,
            loading
        } = this.props;

        let pageVersionJSON;

        if (pageVersion !== null) {
            pageVersionJSON = JSON.parse(pageVersion.json);
        }

        return (
            pageVersion !== null &&
            <Dialog
                disableBackdropClick={true}
                BackdropComponent={BackDropCMS}
                maxWidth={false}
                open={open}
                fullWidth
                classes={{
                    paper: classes.paper,
                    fullWidth: classes.fullWidth
                }}
            >
                <DialogTitle>
                    <Grid container spacing={0}>
                        <Grid item xs={6}>
                            <Typography variant="subheading" gutterBottom color="primary">Active version on the website</Typography>
                        </Grid>
                        <Grid item xs={6} className={classes.selectedVersionText}>
                            <Typography variant="subheading" gutterBottom color="secondary">Selected version to view (number {pageVersion.version})</Typography>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={0}>
                        <Grid container className={classes.compareMetaSection} id="meta-section">
                            <Grid item xs={6}>
                                <PageBuilderMeta
                                    page={pageMeta}
                                    title={pageMeta.title}
                                    subheading={pageMeta.subheading}
                                    classes={classes}
                                    hideActions={true}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <PageBuilderMeta
                                    page={pageVersionJSON.page}
                                    title={pageVersionJSON.page.title}
                                    subheading={pageMeta.subheading}
                                    classes={classes}
                                    hideActions={true}
                                />
                            </Grid>
                        </Grid>
                        <Grid container id="section-list">
                            <Grid item xs={6}>
                                <SectionListEditable
                                    pageId={this.props.pageId}
                                    pageSections={pageSections}
                                    siteId={pageMeta.site_id}
                                    hideActions={true}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <SectionListEditable
                                    pageId={this.props.pageId}
                                    pageSections={pageVersionJSON.sections}
                                    siteId={pageMeta.site_id}
                                    hideActions={true}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button variant="raised" onClick={(ev) => handleCloseView(ev)}>
                        Cancel
                    </Button>
                    <Button onClick={(pageVersion) => handleSubmitView(pageVersion)} variant="raised" color="primary" type="submit" disabled={loading} autoFocus>
                        {loading ? "Please wait!" : "Choose this Version (number " + pageVersion.version + ")"}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default PageVersionViewPopup;


// WEBPACK FOOTER //
// ./src/containers/builder/versions/PageVersionViewPopup.jsx